import {
  cilCircle,
  cilHome,
  cilSpeedometer,
  cilUser,
} from "@coreui/icons";
import CIcon from "@coreui/icons-react";
import { CNavGroup, CNavItem } from "@coreui/react";
import React from "react";

const nav = [
  {
    component: CNavItem,
    name: "Dashboard",
    to: "/admin/dashboard",
    icon: <CIcon icon={cilSpeedometer} customClassName="nav-icon" />,
  },
  {
    component: CNavGroup,
    name: "Property Management",
    to: "/admin/property",
    icon: <CIcon icon={cilHome} customClassName="nav-icon" />,
    items: [
      {
        component: CNavItem,
        name: "Property List",
        to: "/admin/property",
        icon: <CIcon icon={cilCircle} customClassName="nav-icon" />,
      },
      {
        component: CNavItem,
        name: "Add Property",
        to: "/admin/add-property",
        icon: <CIcon icon={cilCircle} customClassName="nav-icon" />,
      },
    ],
  },
  {
    component: CNavGroup,
    name: "Agent Management",
    to: "/admin/agent",
    icon: <CIcon icon={cilUser} customClassName="nav-icon" />,
    items: [
      {
        component: CNavItem,
        name: "Agent List",
        to: "/admin/agent",
        icon: <CIcon icon={cilCircle} customClassName="nav-icon" />,
      },
      {
        component: CNavItem,
        name: "Add Agent",
        to: "/admin/add-agent",
        icon: <CIcon icon={cilCircle} customClassName="nav-icon" />,
      },
    ],
  },
  {
    component: CNavGroup,
    name: "Developer Management",
    to: "/admin/developer",
    icon: <CIcon icon={cilUser} customClassName="nav-icon" />,
    items: [
      {
        component: CNavItem,
        name: "Developer List",
        to: "/admin/developer",
        icon: <CIcon icon={cilCircle} customClassName="nav-icon" />,
      },
      {
        component: CNavItem,
        name: "Add Developer",
        to: "/admin/add-developer",
        icon: <CIcon icon={cilCircle} customClassName="nav-icon" />,
      },
    ],
  },
  {
    component: CNavItem,
    name: "Invest / Leads Mgt.",
    to: "/admin/invest-leads",
    icon: <CIcon icon={cilHome} customClassName="nav-icon" />,
  },
  {
    component: CNavGroup,
    name: "Transactions Mgt.",
    to: "/admin/transaction",
    icon: <CIcon icon={cilHome} customClassName="nav-icon" />,
    items: [
      {
        component: CNavItem,
        name: "Transaction List",
        to: "/admin/transaction",
        icon: <CIcon icon={cilCircle} customClassName="nav-icon" />,
      },
    ],
  },
  {
    component: CNavGroup,
    name: "Rent Mgt.",
    to: "/admin/rent",
    icon: <CIcon icon={cilHome} customClassName="nav-icon" />,
    items: [
      {
        component: CNavItem,
        name: "Rent List",
        to: "/admin/rent",
        icon: <CIcon icon={cilCircle} customClassName="nav-icon" />,
      },
    ],
  },
    {
    component: CNavGroup,
    name: "Partner Mgt.",
    to: "/admin/partner",
    icon: <CIcon icon={cilHome} customClassName="nav-icon" />,
    items: [
      {
        component: CNavItem,
        name: "Partner List",
        to: "/admin/partner",
        icon: <CIcon icon={cilCircle} customClassName="nav-icon" />,
      },
    ],
  },
];

export default nav;
